module.exports = __webpack_public_path__ + "static/play_download_btn-564002452f6b8980dce59536b1078c8b.png";